import { useTopImpactStories } from '../../../shared/hooks/useTopImpactStories';
import type { TopStoryDesktop } from '../../../shared/types';

type Result = ModelHookResult<
	{
		desktopStories: TopStoryDesktop[];
	},
	{
		trackStoryClick: (url: string) => void;
	}
>;

const getPositionClasses = (index: number) => {
	switch (index) {
		case 1:
			return {
				top: 'top-[420px]',
				transform: 'translate-x-[-80%] translate-y-[-10%]',
				isDesktopCentered: false,
			};
		case 2:
			return {
				isDesktopCentered: true,
			};
		case 3:
			return {
				top: 'top-[420px]',
				transform: 'translate-x-[80%] translate-y-[-10%]',
				isDesktopCentered: false,
			};
		default:
			return {
				top: 'top-[60px]',
				isDesktopCentered: false,
			};
	}
};

export function useTopImpactStoriesDesktop(): Result {
	const {
		data: { topStories },
		actions: { trackStoryClick },
	} = useTopImpactStories();

	return {
		data: {
			desktopStories: topStories.map((story, index) => ({
				...story,
				...getPositionClasses(index),
			})),
		},
		actions: {
			trackStoryClick,
		},
	};
}
